import {Link, LinkProps} from '@tanstack/react-router';
import {ReactNode} from 'react';
import {cn} from '../../libs';

interface PaginationButtonSideProps extends LinkProps {
  children: ReactNode;
  disabled?: boolean;
}

export const PaginationButtonSide = ({
  children,
  disabled = false,
  ...rest
}: PaginationButtonSideProps) => (
  <Link
    {...rest}
    className={cn(
      'flex h-10 cursor-pointer items-center gap-2 rounded-md border border-[transparent] px-4 font-sans text-sm transition-colors',
      'hover:bg-bg-secondary',
      'hover:border-border-primary',
      disabled && 'pointer-events-none text-text-disabled',
    )}
  >
    {children}
  </Link>
);
